export default "__VITE_ASSET__c6cd701f__"